/*eslint-disable*/
import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import ReactModal from 'react-modal';
import closeSvg from 'src/assets/close.svg';
import { useTranslation } from 'react-i18next';
import { DatePicker, RegularButton, HorizonDropdown, ICommonDropdownOption, CommonInput } from 'pg-ui-library';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { ICompany } from '../../../interfaces';
import { DateTime } from 'luxon';

import InvoiceService from 'src/services/invoice.service';
import {
  CloseIcon,
  Content,
  ContentContainer,
  FormTitle,
  Header,
  BottomContainer,
  Field,
  SectionTitle,
  FullRow,
  SearchDropdown,
  LoadingText,
  SearchItem,
  DropdownWrapper,
} from './filtersStyles';
interface NewFiltersReviewModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  updateFilters: (
    fromDate: Date | null,
    toDate: Date | null,
    selectedCompany: any,
    status: string,
    employmentType: string,
    showInvocieId: string,
    assignmentId: string,
    accountingId: string,
    employmentStatus: string,
    // clientName: string,
    selectedClients: string,
    hireType: string,
    employeeName: string,
    dateCriteria: string,
    dateRangeType: string
  ) => void;
  statusOptions: ICommonDropdownOption[];
  hireTypeMode?: 'normal' | 'w2Only';
}

export const NewFiltersExpense: React.FC<NewFiltersReviewModalProps> = ({
  isOpen,
  setIsOpen,
  updateFilters,
  statusOptions,
  hireTypeMode = 'normal',
}) => {
  const { t } = useTranslation();

  const statusContainerRef = useRef<HTMLDivElement>(null);
  const hireTypeContainerRef = useRef<HTMLDivElement>(null);

  // --- Filter States ---
  const [dateRangeType, setDateRangeType] = useState<string>(''); // Before | After | Between | Exactly
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);

  // const [selectedStatuses, setSelectedStatuses] = useState<string[]>(['']);

  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
  // const [selectedHireTypes, setSelectedHireTypes] = useState<string[]>([]);
  const [selectedHireTypes, setSelectedHireTypes] = useState<string[]>(hireTypeMode === 'w2Only' ? ['W2'] : []);

  const [isStatusFocused, setIsStatusFocused] = useState(false);
  const [isHireTypeFocused, setIsHireTypeFocused] = useState(false);

  const [employmentType, setEmploymentType] = useState<string>('');
  const [showInvocieId, setshowInvocieId] = useState<string>('');
  const [accountingId, setAccountingId] = useState<string>('');
  const [assignmentId, setAssignmentId] = useState<string>('');
  const [employmentStatus, setEmploymentStatus] = useState<string>('');
  const [employeeName, setEmployeeName] = useState<string>('');
  // const [clientName, setClientName] = useState<string>('');
  const [selectedClients, setSelectedClients] = useState<string[]>([]);

  const { data } = useTypedSelector(state => state.companies);
  const { config } = useTypedSelector(state => state.config.data);

  const [clientOptions, setClientOptions] = useState<ICommonDropdownOption[]>([]);
  const [clientSearchValue, setClientSearchValue] = useState<string>('');
  const [isClientLoading, setIsClientLoading] = useState<boolean>(false);
  const [isClientFocused, setIsClientFocused] = useState(false);
  const [dateCriteria, setDateCriteria] = useState<string>('period');

  const [selectedCompany, setSelectedCompany] = useState<string>('');
  const [currentCompany, setCurrentCompany] = useState<ICompany>();

  const [dropdownOptionsCompany, setDropdownOptionsCompany] = useState<ICommonDropdownOption[]>([]);

  const [dropdownOptionsHireType, setDropdownOptionsHireType] = useState<ICommonDropdownOption[]>([
    { key: 'W2', label: 'W2', value: 'W2' },
    { key: 'C2C', label: 'C2C', value: 'C2C' },
    { key: '1099', label: '1099', value: '1099' },
    { key: 'Payroll', label: 'Payroll', value: 'Payroll' },
    { key: 'IndependentContractor', label: 'Independent Contractor', value: 'IC' },
    // { key: '', label: 'All', value: '' },
  ]);

  const [dropdownOptionsDateRange, setDropdownOptionsDateRange] = useState<ICommonDropdownOption[]>([
    { key: 'select', label: 'Select Range', value: '' },
    { key: 'before', label: 'Before', value: 'before' },
    { key: 'after', label: 'After', value: 'after' },
    { key: 'between', label: 'Between', value: 'between' },
    { key: 'exactly', label: 'Exactly', value: 'exactly' },
  ]);

  const [dropdownOptionsDateField, setDropdownOptionsDateField] = useState<ICommonDropdownOption[]>([
    { key: 'period', label: 'Work Week', value: 'period' },
    { key: 'submittedDate', label: 'Submitted Date', value: 'submittedDate' },
    { key: 'approvedDate', label: 'Approved Date', value: 'approvedDate' },
    { key: 'billedDate', label: 'Billed Date', value: 'billedDate' },
    { key: 'payrolledDate', label: 'Payrolled Date', value: 'payrolledDate' },
  ]);

  // --- Initialize company dropdown ---

  useEffect(() => {
    const emptyCompany: ICompany = { id: '', name: 'All', legalEntityId: '' };

    const prideGlobal: ICompany = {
      id: 'pride-global-id',
      name: 'Pride Global',
      legalEntityId: 'pride-global',
    };

    const prideIndia: ICompany = {
      id: 'pride-India-id',
      name: 'Pride India',
      legalEntityId: 'pride-India',
    };

    const companiesWithExtra = [emptyCompany, prideGlobal, prideIndia, ...data.companies];

    const cpnsOptions = companiesWithExtra.map((item: ICompany) => ({
      key: item.id,
      label: item.name,
      value: item.name, // ✅ important (you already fixed this)
    }));

    setDropdownOptionsCompany(cpnsOptions);
  }, [data.companies]);

  useEffect(() => {
    if (!isOpen) return;

    const fetchInitialClients = async () => {
      try {
        setIsClientLoading(true);

        const response = await InvoiceService.searchClients({
          clientSearch: '',
          limit: 20,
        });

        const formatted = response.map((client: any) => ({
          key: client.clientId,
          label: client.clientName,
          value: client.clientName,
        }));

        setClientOptions(formatted);
      } catch (err) {
        console.error(err);
      } finally {
        setIsClientLoading(false);
      }
    };

    fetchInitialClients();
  }, [isOpen]);

  useEffect(() => {
    const delayDebounce = setTimeout(async () => {
      try {
        setIsClientLoading(true);

        const response = await InvoiceService.searchClients({
          clientSearch: clientSearchValue || '',
          limit: 20,
        });

        const formatted = response.map((client: any) => ({
          key: client.clientId,
          label: client.clientName,
          value: client.clientName,
        }));

        setClientOptions(formatted);
      } catch (error) {
        console.error(error);
      } finally {
        setIsClientLoading(false);
      }
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [clientSearchValue]);

  useEffect(() => {
    if (!isStatusFocused) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const container = statusContainerRef.current;

      if (!container) return;

      // IMPORTANT: also ignore clicks inside dropdown
      const dropdown = document.getElementById('status-dropdown');

      if (container.contains(target) || (dropdown && dropdown.contains(target))) {
        return;
      }

      setIsStatusFocused(false);
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isStatusFocused]);

  useEffect(() => {
    if (!isHireTypeFocused) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const container = hireTypeContainerRef.current;
      const dropdown = document.getElementById('hiretype-dropdown');

      if (container?.contains(target) || dropdown?.contains(target)) {
        return;
      }

      setIsHireTypeFocused(false);
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isHireTypeFocused]);

  useEffect(() => {
    if (hireTypeMode === 'w2Only') {
      setSelectedHireTypes(['W2']);
    }
  }, [hireTypeMode]);

  const defineInitialValue = () => {
    if (config?.selectedCompanyId) {
      const cpn = data.companies.find(company => company.id === config.selectedCompanyId);
      setCurrentCompany(cpn);
    } else {
      const cpn = data.companies[0];
      setCurrentCompany(cpn);
    }
  };

  // const filterApply = () => {
  //   updateFilters(
  //     fromDate,
  //     toDate,
  //     selectedCompany,
  //     // status,
  //     selectedStatuses.join(','),
  //     employmentType,
  //     showInvocieId,
  //     assignmentId.trim(),
  //     accountingId.trim(),
  //     employmentStatus,
  //     // clientName,
  //     selectedClients.join(','),
  //     // hireType,
  //     selectedHireTypes.join(','),
  //     employeeName,
  //     dateCriteria,
  //     dateRangeType
  //   );
  //   setIsOpen(false);
  // };

  const filterApply = () => {
    updateFilters(
      fromDate,
      toDate,
      selectedCompany,
      selectedStatuses.join(','),
      employmentType,
      showInvocieId,
      assignmentId.trim(),
      accountingId.trim(),
      employmentStatus,
      selectedClients.join(','),
      hireTypeMode === 'w2Only' ? 'W2' : selectedHireTypes.join(','),
      employeeName,
      dateCriteria,
      dateRangeType
    );

    setIsOpen(false);
  };

  const clearApply = () => {
    setDateRangeType('');
    setFromDate(null);
    setToDate(null);
    // setStatus('');
    setSelectedStatuses([]);
    setSelectedHireTypes([]);
    setEmploymentType('');
    setshowInvocieId('');
    setAccountingId('');
    setAssignmentId('');
    setEmploymentStatus('');
    setSelectedCompany('');
    setEmployeeName('');
    // setClientName('');
    setSelectedClients([]);
    updateFilters(null, null, '', '', '', '', '', '', '', '', '', '', '', '');
    setIsOpen(false);

    // setClientName('');
    setClientSearchValue('');
    setClientOptions([]);
  };

  const handleDateChange = (date: Date | null, setter: Function) => setter(date);
  const handleModalClose = () => setIsOpen(false);

  const isFromDateEnabled = ['before', 'after', 'between', 'exactly'].includes(dateRangeType);
  const isToDateEnabled = dateRangeType === 'between';

  const toggleClientSelection = (client: string) => {
    setSelectedClients(prev => (prev.includes(client) ? prev.filter(c => c !== client) : [...prev, client]));
  };

  const toggleStatusSelection = (value: string) => {
    setSelectedStatuses(prev => (prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]));
  };

  const displayValue = selectedStatuses
    .map(val => statusOptions.find(option => option.value === val)?.label)
    .filter(Boolean)
    .join(', ');

  const toggleHireTypeSelection = (value: string) => {
    setSelectedHireTypes(prev => (prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]));
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleModalClose}
      ariaHideApp={false}
      style={{
        overlay: { margin: 'auto', backgroundColor: 'rgba(0, 0, 0, 0.6)' },
        content: {
          borderRadius: '30px',
          backgroundColor: '#F3F4F8',
          margin: 'auto',
          width: '90vw',
          maxWidth: '1100px',
          height: '500px',
          // display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '20px',
          gap: '20px',
        },
      }}
    >
      <Header>
        <FormTitle>{t('employeeReviewChanges.newFilters')}</FormTitle>
        <CloseIcon src={closeSvg} onClick={handleModalClose} />
      </Header>

      <ContentContainer>
        <Content>
          {/* Row 1 */}
          <Field>
            <label>Company</label>
            <DropdownWrapper>
              <HorizonDropdown
                label=""
                setValue={setSelectedCompany}
                value={selectedCompany}
                placeholder="Select Company"
                options={dropdownOptionsCompany}
              />
            </DropdownWrapper>
          </Field>

          <Field>
            <label>Client</label>

            <CommonInput
              label=""
              placeholder="Search Client"
              value={isClientFocused ? clientSearchValue : selectedClients.join(', ')}
              onFocus={() => setIsClientFocused(true)}
              onBlur={() => setTimeout(() => setIsClientFocused(false), 200)}
              onChange={e => {
                const value = e.target.value;

                setSelectedCompany('');
                setClientSearchValue(value);
                setIsClientFocused(true);
              }}
              style={{
                width: '100%',
                borderRadius: '7px',
                border: '1px solid #ccc',
              }}
            />

            {isClientFocused && (
              <SearchDropdown
                onMouseDown={e => {
                  e.preventDefault();
                }}
              >
                {isClientLoading && <LoadingText>Searching...</LoadingText>}

                {!isClientLoading && clientOptions.length === 0 && clientSearchValue && (
                  <LoadingText>No clients found</LoadingText>
                )}

                {!isClientLoading &&
                  clientOptions.map(option => (
                    <SearchItem key={option.key} onClick={() => toggleClientSelection(option.value)}>
                      <input
                        type="checkbox"
                        checked={selectedClients.includes(option.value)}
                        readOnly
                        style={{ marginRight: '8px' }}
                      />
                      {option.label}
                    </SearchItem>
                  ))}
              </SearchDropdown>
            )}
          </Field>

          <Field>
            <label>Worker Name</label>
            <CommonInput
              label=""
              placeholder="Enter worker name"
              value={employeeName}
              onChange={e => setEmployeeName(e.target.value)}
            />
          </Field>

          <Field>
            <label>Hire Type</label>
            <DropdownWrapper ref={hireTypeContainerRef}>
              {/* <CommonInput
                label=""
                placeholder="Select Hire Type"
                value={selectedHireTypes.join(', ')}
                onFocus={() => setIsHireTypeFocused(true)}
                readOnly
              /> */}
              <CommonInput
                label=""
                placeholder="Select Hire Type"
                value={selectedHireTypes.join(', ')}
                onFocus={() => {
                  if (hireTypeMode !== 'w2Only') {
                    setIsHireTypeFocused(true);
                  }
                }}
                readOnly
                disabled={hireTypeMode === 'w2Only'}
              />

              {/* {isHireTypeFocused && */}
              {hireTypeMode !== 'w2Only' &&
                isHireTypeFocused &&
                createPortal(
                  <SearchDropdown
                    id="hiretype-dropdown"
                    style={{
                      position: 'fixed',
                      top: hireTypeContainerRef.current?.getBoundingClientRect().bottom ?? 0,
                      left: hireTypeContainerRef.current?.getBoundingClientRect().left ?? 0,
                      width: hireTypeContainerRef.current?.offsetWidth ?? 250,
                    }}
                  >
                    {dropdownOptionsHireType.map(option => (
                      <SearchItem
                        key={option.key}
                        onMouseDown={e => {
                          e.preventDefault();
                          toggleHireTypeSelection(option.value);
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={selectedHireTypes.includes(option.value)}
                          readOnly
                          style={{ marginRight: 8 }}
                        />
                        {option.label}
                      </SearchItem>
                    ))}
                  </SearchDropdown>,
                  document.body
                )}
            </DropdownWrapper>
          </Field>

          {/* Row 2 */}
          <Field>
            <DropdownWrapper>
              <label>Status</label>
              <div ref={statusContainerRef}>
                <CommonInput
                  label=""
                  placeholder="Select Status"
                  // value={selectedStatuses.join(', ')}
                  value={displayValue}
                  onFocus={() => setIsStatusFocused(true)}
                  readOnly
                />
              </div>
              {isStatusFocused &&
                createPortal(
                  <SearchDropdown
                    id="status-dropdown"
                    style={{
                      position: 'fixed',
                      top: statusContainerRef.current?.getBoundingClientRect().bottom ?? 0,
                      left: statusContainerRef.current?.getBoundingClientRect().left ?? 0,
                      width: statusContainerRef.current?.offsetWidth ?? 250,
                    }}
                  >
                    {statusOptions.map(option => (
                      <SearchItem
                        key={option.key}
                        onMouseDown={e => {
                          e.preventDefault(); // prevents blur race condition
                          toggleStatusSelection(option.value);
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={selectedStatuses.includes(option.value)}
                          readOnly
                          style={{ marginRight: 8 }}
                        />
                        {option.label}
                      </SearchItem>
                    ))}
                  </SearchDropdown>,
                  document.body
                )}
            </DropdownWrapper>
          </Field>

          <Field>
            <label>Expense ID</label>
            <CommonInput
              label=""
              placeholder="Enter Expense ID"
              value={showInvocieId}
              onChange={e => setshowInvocieId(e.target.value)}
            />
          </Field>

          <Field>
            <label>Accounting ID</label>
            <CommonInput
              label=""
              placeholder="Enter Accounting ID"
              value={accountingId}
              onChange={e => setAccountingId(e.target.value)}
            />
          </Field>

          <Field>
            <label>Assignment ID</label>
            <CommonInput
              label=""
              placeholder="Enter Assignment ID"
              value={assignmentId}
              onChange={e => setAssignmentId(e.target.value)}
            />
          </Field>

          {/* Date Range Section */}
          <SectionTitle>Date Range</SectionTitle>

          <FullRow>
            <Field>
              <label>Date Type</label>
              <DropdownWrapper>
                <HorizonDropdown
                  label=""
                  setValue={setDateCriteria}
                  value={dateCriteria}
                  placeholder="Select Date Type"
                  options={dropdownOptionsDateField}
                />
              </DropdownWrapper>
            </Field>

            <Field>
              <label>Date Filter Type</label>
              <DropdownWrapper>
                <HorizonDropdown
                  label=""
                  setValue={setDateRangeType}
                  value={dateRangeType}
                  placeholder="Select Date Range"
                  options={dropdownOptionsDateRange}
                />
              </DropdownWrapper>
            </Field>

            <Field>
              <label>Start Date</label>
              <DatePicker
                id="fromDate"
                name="fromDate"
                label=""
                autoComplete="off"
                selected={fromDate}
                onChange={date => handleDateChange(date, setFromDate)}
                disabled={!isFromDateEnabled}
                dateFormat="MM/dd/yyyy"
              />
            </Field>

            <Field>
              <label>End Date</label>
              <DatePicker
                id="toDate"
                name="toDate"
                label=""
                autoComplete="off"
                selected={toDate}
                onChange={date => handleDateChange(date, setToDate)}
                disabled={!isToDateEnabled}
                minDate={fromDate ?? undefined}
                dateFormat="MM/dd/yyyy"
              />
            </Field>
          </FullRow>
        </Content>

        <BottomContainer>
          <RegularButton onClick={filterApply}>{t('global.button.search')}</RegularButton>
          <RegularButton onClick={clearApply}>{t('global.button.clear')}</RegularButton>
        </BottomContainer>
      </ContentContainer>
    </ReactModal>
  );
};
